import type { Catalog } from "../../en";

/** Filipino: Audiences & Access (/w/:ws/audiences/:tab?) (mirrors en). */
export const audiences: Catalog["deployKnowledge"]["audiences"] = {
  title: "Audience at Access",
  subtitleLead: "Pagpasyahan kung sino ang makakakita ng ano. Sinasala ayon sa audience ang mga dokumento at sagot",
  subtitleBefore: "bago",
  subtitleTail: "pa ito makita ng AI, kaya hindi kailanman makakakuha ang pampublikong bisita ng sagot mula sa restricted na file.",
  testAs: "Subukan bilang audience",
  explainerTitle: "Paano gumagana ang access filtering",
  explainerBody:
    "Kapag may nagtanong, tinitingnan muna ng Sagot kung sino siya (anonymous, beripikadong contact, naka-sign-in na miyembro, staff), saka hahanapin lamang ang mga knowledge source na abot ng kanyang audience. Kapag walang tugma, sasabihin ng agent na hindi ito makatutulong at mag-aalok ng handoff. Hindi ito nanghuhula mula sa restricted na file.",
  tabsLabel: "Mga seksyon ng Audience at Access",
  tabAudiences: "Mga audience",
  tabMatrix: "Access matrix",
  tabUsers: "Mga end user",
  tabIdp: "Mga identity provider",
  default: "Default",
  noDescription: "Wala pang paglalarawan",
  endUsersUnit: "end user",
  verifiedBy: "Beripikado sa",
  canAccess: "May access sa",
  everythingPublic: "Lahat ng pampubliko",
  allSources_one: "Lahat ng {{count}} source",
  allSources_other: "Lahat ng {{count}} source",
  moreSources_one: "+{{count}} pa",
  moreSources_other: "+{{count}} pa",
  noSources: "Wala pang source",
  agentsLine: "Mga agent: {{agents}}",
  noAgents: "Wala pang agent na gumagamit ng audience na ito",
  edit: "I-edit",
  editNamed: "I-edit ang {{name}}",
  editAccess: "I-edit ang access",
  viewAccess: "Tingnan ang access",
  emptyTitle: "Wala pang audience",
  emptyBody: "Lalabas dito ang mga audience kapag na-set up na ang workspace.",
  editTitle: "I-edit ang “{{name}}”",
  editHint: "Lumalabas ang pangalan sa access matrix, knowledge base at settings ng agent.",
  labelField: "Pangalan",
  labelRequired: "Bigyan ng pangalan ang audience",
  descriptionField: "Paglalarawan",
  descriptionHint: "Sino ang kabilang dito, hal. “Kahit sino sa aming website”.",
  methodField: "Paano sila bineberipika?",
  methodUnset: "Hindi nakatakda",
  saved: "Na-save ang “{{name}}”",
  methods: {
    anonymous: "Anonymous",
    widget_jwt: "Pinirmahang widget token (JWT)",
    portal_sso: "Sign-in sa portal (JWT)",
    google_workspace: "Google Workspace",
    microsoft_entra: "Microsoft Entra ID",
    email_otp: "Email code",
    roster: "Pagsuri ng ID sa roster",
  },
  matrixHint: "Lagyan ng tsek para masagot ang mga tanong ng audience mula sa source na iyon. Hindi awtomatikong namamana ng mas mataas na audience.",
  matrixSave: "I-save ang access",
  matrixSaved: "Na-save ang access. Sinasala na ang mga sagot ayon sa bagong patakaran.",
  matrixAffected_one: "Gagamitin ng {{count}} agent ang pagbabago sa susunod nitong sagot.",
  matrixAffected_other: "Gagamitin ng {{count}} agent ang pagbabago sa susunod nilang sagot.",
  matrixSource: "Knowledge source",
  matrixCell: "{{source}} para sa {{audience}}",
  matrixLast: "Kailangan ng bawat source ng kahit isang audience",
  matrixFailed: "Pumalya ang pagproseso — panatilihing restricted hanggang maayos",
  matrixInherits: "Minamana ang audience mula sa mga agent nito",
  matrixNoteRestricted: "Hindi kailanman ipinapadala sa model ang restricted na source para sa ibang audience.",
  matrixNoteOcr: "Mababang OCR confidence: panatilihing restricted hanggang may mas malinaw na kopya.",
  matrixEmptyTitle: "Wala pang knowledge source",
  matrixEmptyBody: "Magdagdag ng dokumento, website o Q&A sa isang agent, saka pagpasyahan dito kung sino ang makakakita.",
  matrixEmptyCta: "Pumunta sa mga agent",
  usersHint: "Mga taong kumakausap sa iyong mga agent · {{total}} lahat",
  usersSearch: "Hanapin ang pangalan, ID, email…",
  usersAudienceFilter: "Salain ayon sa audience",
  allAudiences: "Lahat ng audience",
  importCsv: "Mag-import ng CSV",
  importHint: "Mga column: {{columns}} (audiences tulad ng 1|3).",
  importTitle: "Tapos na ang import",
  importCreated: "Nagawa",
  importUpdated: "Na-update",
  importSkipped: "Nilaktawan",
  importErrors_one: "{{count}} row ang kailangang ayusin",
  importErrors_other: "{{count}} row ang kailangang ayusin",
  importRow: "Row {{row}}",
  importClean: "Na-import ang lahat ng row.",
  colName: "Pangalan",
  colRole: "Role",
  colSegment: "Grupo",
  colAudience: "Audience",
  colLastActive: "Huling aktibo",
  colConversations: "Mga usapan",
  colStatus: "Status",
  colActions: "Mga aksyon",
  anonymousUser: "Bisitang walang pangalan",
  usersEmptyTitle: "Wala pang end user",
  usersEmptyBody: "Lalabas ang mga end user kapag nagpa-verify sila sa chat, o i-import mula sa CSV ({{columns}}).",
  usersNoMatch: "Walang end user na tugma sa mga filter",
  usersShowing: "Ipinapakita ang {{shown}} sa {{total}}",
  paginationNav: "Mga page ng end user",
  previousPage: "Nakaraang page",
  nextPage: "Susunod na page",
  pageN: "Page {{page}}",
  pageOf: "Page {{page}} sa {{count}}",
  status: {
    active: "Aktibo",
    verified: "Beripikado",
    invited: "Inimbitahan",
    blocked: "Naka-block",
  },
  userActions: "Mga aksyon sa end user",
  userActionsFor: "Mga aksyon para kay {{name}}",
  viewConversations: "Tingnan ang mga usapan",
  changeAudience: "Palitan ang audience",
  changeAudienceHint: "Laging kasama ang pampubliko. Magkakabisa sa susunod nilang mensahe.",
  saveAudience: "I-save ang audience",
  audienceChanged: "Napalitan ang audience. Magkakabisa sa susunod nilang mensahe.",
  block: "I-block ang user",
  unblock: "I-unblock ang user",
  blocked: "Naka-block na si {{name}} sa lahat ng agent",
  unblocked: "Makakapag-chat na muli si {{name}}",
  idp: {
    connected: "Nakakonekta",
    notConnected: "Hindi nakakonekta",
    off: "Naka-off",
    enable: "Tanggapin ang sign-in mula sa provider na ito",
    enableNamed: "I-enable ang {{name}}",
    enabledToast: "Na-enable ang {{name}}",
    disabledToast: "Na-disable ang {{name}}",
    configure: "I-configure",
    connect: "Ikonekta",
    disconnect: "Idiskonekta",
    rosterReadOnly: "Pinamamahalaan ng roster import. I-on o i-off dito.",
    configureTitle: "I-configure ang {{name}}",
    connectTitle: "Ikonekta ang {{type}}",
    saved: "Na-save ang {{name}}",
    deleted: "Nadiskonekta ang {{name}}",
    deleteTitle: "Idiskonekta ang {{name}}?",
    deleteBody: "Mawawalan ng access sa restricted na sagot ang mga beripikado rito hanggang magpa-verify sila sa ibang paraan. Hindi na ito maibabalik.",
    name: "Display name",
    nameRequired: "Bigyan ng pangalan ang provider",
    issuer: "Issuer (iss)",
    audience: "Audience (aud)",
    algorithm: "Algorithm",
    jwksUrl: "JWKS URL",
    sharedSecret: "Shared secret",
    secretHint: "Write-only. Iwanang blangko para panatilihin ang kasalukuyang secret.",
    claimMapping: "Pag-map ng claim",
    claim: "Claim {{n}}",
    claimValue: "Value ng claim {{n}}",
    mapsTo: "Audience ng row {{n}}",
    removeRow: "Alisin ang row {{n}}",
    addClaim: "Magdagdag ng claim",
    groupMapping: "Grupo → audience",
    group: "Grupo {{n}}",
    addGroup: "Magdagdag ng grupo",
    pickAudience: "Pumili ng audience",
    grants: "Naka-map sa audience",
    grantsHint: "Makukuha ng mga beripikado ang mga audience na ito (kasama ang pampubliko).",
    mapsToNone: "Pampubliko lamang",
    lastVerified: "Huling beripikadong token",
    never: "Hindi pa",
    domain: "Pinapayagang domain",
    tenantId: "Tenant ID",
    clientId: "Application (client) ID",
    clientSecret: "Client secret",
    redirectUri: "Redirect URI",
    redirectHint: "Idagdag ito sa Azure portal → App registrations → Authentication.",
    redirectAfterSave: "Lalabas dito ang redirect URI pagkatapos mong ikonekta.",
    signExample: "Halimbawa: pumirma ng token sa iyong portal (Node.js)",
    requiredDomain: "Kailangan ng Google Workspace ang pinapayagang domain.",
    requiredEntra: "Kailangan ng Microsoft Entra ID ang tenant ID at application (client) ID.",
    requiredPortal: "Kailangan ng sign-in sa portal ang issuer at JWKS URL o shared secret.",
    types: {
      portal_sso: "Sign-in sa portal (JWT)",
      widget_jwt: "Pinirmahang widget token",
      google_workspace: "Google Workspace",
      microsoft_entra: "Microsoft Entra ID",
      email_otp: "Email code",
      roster: "Pagsuri ng ID sa roster",
    },
    descriptions: {
      portal_sso: "Pumipirma ang iyong portal ng token na may ID at role ng miyembro. Ipinapasa ito ng widget at web app sa bawat mensahe.",
      widget_jwt: "Pumipirma ang iyong site ng panandaliang token para sa widget para makuha ng naka-sign-in na bisita ang kanilang audience.",
      google_workspace: "Nagsa-sign in ang staff gamit ang kanilang Google account. Tanging address sa pinapayagang domain ang tinatanggap.",
      microsoft_entra: "Para sa mga organisasyong nasa Microsoft 365. I-map ang mga Entra group sa mga audience.",
      email_otp: "Kinukumpirma ng tao ang one-time code na ipinadala sa kanilang email address.",
      roster: "Ilalagay ng tao ang kanilang ID at pangalawang patunay, sinusuri laban sa na-import na roster. Naka-hash ang mga ID at hindi kailanman ipinapakita sa AI model.",
    },
  },
};
